import {
	Box,
	Collapse,
	Divider,
	IconButton,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Menu,
	Drawer as MuiDrawer,
	Link as MuiLink,
	Stack,
	Typography,
	useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SterisSmallLogo from '../styles/img/STERIS-LogoSmall.png';
import AccessLogs from '../styles/img/assets/AccessLogs.png';
import CycleActionStatus from '../styles/img/assets/CycleActionStatus.png';
import dashboard from '../styles/img/assets/Dashboard.png';
import EndoscopeIcon from '../styles/img/assets/Endoscope.png';
import EquipmentType from '../styles/img/assets/Equipment Type.png';
import Equipment from '../styles/img/assets/Equipment.png';
import Holiday from '../styles/img/assets/Holiday.png';
import Indicator from '../styles/img/assets/Indicator.png';
import LocationWhite from '../styles/img/assets/Location-white.png';
import LotDetails from '../styles/img/assets/Lot details.png';
import Modality from '../styles/img/assets/MOdality.png';
import TaskAssignment from '../styles/img/assets/Task Assignment.png';
import TaskType from '../styles/img/assets/TaskType.png';
import Tasks from '../styles/img/assets/Tasks.png';
import admin from '../styles/img/assets/admin.png';
import broker from '../styles/img/assets/broker.png';
import client from '../styles/img/assets/client.png';
import config from '../styles/img/assets/config.png';
import cycleIcon from '../styles/img/assets/cycle.png';
import fileIcon from '../styles/img/assets/file.png';
import hospitalIcon from '../styles/img/assets/hospital.png';
import incubator from '../styles/img/assets/incubator.png';
import items from '../styles/img/assets/items.png';
import logs from '../styles/img/assets/logs.png';
import MenuLogo from '../styles/img/assets/menu.png';
import reuseIcon from '../styles/img/assets/reuse.png';
import topicpermission from '../styles/img/assets/topicpermission.png';
import transaction from '../styles/img/assets/transaction.png';
import users from '../styles/img/assets/users.png';
import AvatarLogo from '../styles/img/avtar.jpg';
import '../styles/style.css';
import { useSnackbar } from "@durlabh/dframework-ui";
import Chemistry from '../styles/img/assets/Chemistry.png';
import Detergent from '../styles/img/assets/Detergent.png';
import ScmRegion from '../styles/img/assets/ScmRegion.png';
import ScmCountry from '../styles/img/assets/Globe.png';
import ScopeMaster from  '../styles/img/assets/ScopeMaster.png';
const icons = {
	menu: MenuLogo,
	hospital: hospitalIcon,
	avtar: AvatarLogo,
	default: AvatarLogo,
	'AccessLogs ': AccessLogs,
	admin,
	file: fileIcon,
	dashboard,
	config,
	reuse: reuseIcon,
	client,
	topicpermission,
	logs,
	incubator,
	cycle: cycleIcon,
	transaction,
	items,
	broker,
	users,
	'Location-white': LocationWhite,
	'Equipment Type': EquipmentType,
	Modality,
	Equipment,
	TaskType,
	'Task Assignment': TaskAssignment,
	Tasks,
	Indicator,
	CycleActionStatus,
	Holiday,
	'Lot details': LotDetails,
	Endoscope: EndoscopeIcon,
	Chemistry,
	Detergent,
	ScmRegion,
	ScmCountry,
	ScopeMaster
};
const drawerWidth = 320;
const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen
	}),
	overflowX: 'hidden'
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(9)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(9)} + 1px)`
	}
});

const StyledMenu = styled((props) => (
	props.open && props.anchorEl ? (
		<Menu
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right'
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left'
			}}
			{...props}
		/>
	) : null
))(({ theme }) => ({
	'& .MuiPaper-root': {
		backgroundColor: theme.palette.primary.light,
		color: theme.palette.mode === 'light' ? theme.palette.primary.contrastText : theme.palette.text.primary,
		pointerEvents: 'auto'
	},
	'&[aria-hidden="true"]': {
		pointerEvents: 'none !important'
	}
}));

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	padding: theme.spacing(0, 1),
	marginTop: theme.spacing(10),
	// necessary for content to be below app bar
	...theme.mixins.toolbar
}));

const DrawerBody = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	flex: '1',
	overflowY: 'auto',
	overflowX: 'hidden',
	'& .MuiListItemButton-root': {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		whiteSpace: 'normal',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	'& .MuiListItemText-primary, & .fa': {
		color: theme.palette.background.paper
	},

	'& .SubMenu-Indicator-Icon': {
		color: 'primary.contrastText'
	},
	'& .Nav-Menu-Link': {
		'& .Nav-Menu-Link': { pl: 4 },
		'&.Mui-selected': { backgroundColor: 'action.selected' }
	},
	'& .MuiPaper-root': {
		'&.MuiMenu-paper': {
			backgroundColor: (theme) => `${theme.palette.primary.light} !important`,
			color: 'primary.contrastText'
		}
	},
	'& .Nav-Menu-Popup': {
		'& .Mui-selected': { backgroundColor: 'action.active' },
		'& .MuiListItemButton-root': { backgroundColor: 'action.active' }
	},
	'& .openSection': {
		backgroundColor: theme.palette.action.selected
	},
	'&::-webkit-scrollbar': {
		width: theme.spacing(1.2)
	},

	'&::-webkit-scrollbar-track': {
		boxShadow: 'none',
		webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
		backgroundColor: 'transparent',
		borderRadius: theme.spacing(),
		padding: theme.spacing(0.1)
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: theme.palette.text.disabled,
		borderRadius: theme.spacing(),
		'&:hover': {
			backgroundColor: theme.palette.text.secondary
		},
		'&:focus': {
			backgroundColor: theme.palette.text.secondary
		}
	}
}));

const DrawerFooter = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(2),

	'& hr': {
		backgroundColor: theme.palette.primary.contrastText,
		height: 2
	},
	'& .drawer-footer-logo': {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		height: theme.spacing(5),
		backgroundColor: theme.palette.primary.contrastText,
		marginBottom: theme.spacing(),
		borderRadius: theme.spacing()
	},
	'& .drawer-footer-logo img': {
		width: '70%',
		height: 'auto',
		objectFit: 'contain'
	},
	'& #footerServiceButton': {
		margin: theme.spacing(),
		width: theme.spacing(2.5),
		height: theme.spacing(2.5),
		'& i.fa': {
			color: theme.palette.primary.contrastText,
			fontSize: 12
		}
	}
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
	width: theme.mixins?.drawer?.width || 320,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',

	...(open ? openedMixin(theme) : closedMixin(theme)),
	[`& .MuiDrawer-paper`]: {
		...(open ? openedMixin(theme) : closedMixin(theme)),
		width: useMediaQuery(theme.breakpoints.between('sm', 'md')) ? 290 : drawerWidth,
		boxSizing: 'border-box',
		backgroundColor: theme.palette.primary.light
	},

	[`& .nav-first-submenu .MuiCollapse-root .MuiListItemButton-root`]: {
		paddingLeft: theme.spacing(4)
	},
	[`& .nav-second-submenu .MuiCollapse-root .MuiListItemButton-root`]: {
		paddingLeft: theme.spacing(8)
	}
}));

// Drawer Navigation menu component
const NavMenuSectionLink = ({ text, url, icon, ...rest }) => {
	const location = useLocation();
	const pathname = `/${url ? url : ''}`;
	const navName = text;
	const iconName = icon.replace('images/menu-icon/', '');
	const IconName = icons[iconName] || icons.default;
	return (
		<MuiLink to={pathname} color="inherit" underline="none" component={Link} {...rest}>
			<ListItemButton
				className={`Nav-Menu-Link`}
				selected={location.pathname === pathname}
			>
				<ListItemIcon sx={{ height: 24}}>
					<img className="menu-Icon-Style" title={navName} src={IconName} alt={navName} />
				</ListItemIcon>
				<ListItemText primary={navName.toUpperCase()} />
			</ListItemButton>
		</MuiLink>
	);
};
const NavMenuPopupLink = ({ text, url, icon, ...rest }) => {
	const location = useLocation();
	const pathname = `/${url ? url : ''}`;
	const navName = text;
	const iconName = icon.replace('images/menu-icon/', '');
	const IconName = icons[iconName] || icons.default;
	return (
		<MuiLink to={pathname} color="inherit" underline="none" component={Link} {...rest}>
			<ListItemButton className={`Nav-Menu-Link`} selected={location.pathname === pathname}>
				<ListItemIcon>
					<img className="menu-Icon-Style" title={navName} src={IconName} alt={navName} />
				</ListItemIcon>
				<ListItemText primary={navName.toUpperCase()} />
			</ListItemButton>
		</MuiLink>
	);
};

// Drawer Navigation menu collapsible submenu component
const NavMenuSection = ({ text, icon, children, open, onToggle, className }) => {
	const navName = text;
	const iconName = icon?.replace('images/menu-icon/', '');
	const IconName = icons[iconName] || icons.default;
	const menuAnchorElRef = useRef();

	return (
		<Box className={`${className || ''} ${open ? 'openSection' : ''}`} color="inherit">
			<ListItemButton onClick={onToggle} ref={menuAnchorElRef} color="inherit">
				<ListItemIcon>
					<img className="menu-Icon-Style" title={navName} src={IconName} alt={navName} />
				</ListItemIcon>
				<ListItemText primary={navName.toUpperCase()} />
				{open ? (
					<KeyboardArrowUpIcon className="SubMenu-Indicator-Icon" />
				) : (
					<KeyboardArrowDownIcon className="SubMenu-Indicator-Icon" />
				)}
			</ListItemButton>
			<Collapse in={open} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					{children}
				</List>
			</Collapse>
		</Box>
	);
};

const NavMenuPopup = ({ text, icon, children, open, onToggle, className, menuAnchorEl }) => {
	const navName = text;
	const iconName = icon?.replace('images/menu-icon/', '');
	const IconName = icons[iconName] || icons.default;

	return (
		<Box className={`Nav-Menu-SubSection ${className || ''} ${open ? 'openSection' : ''}`}>
			<ListItemButton selected={open} onClick={onToggle}>
				<ListItemIcon>
					<img className="menu-Icon-Style" title={navName} src={IconName} alt={navName} />
				</ListItemIcon>
				<ListItemText primary={navName.toUpperCase()} />
				{open ? (
					<KeyboardArrowLeftIcon className="SubMenu-Indicator-Icon" />
				) : (
					<KeyboardArrowRightIcon className="SubMenu-Indicator-Icon" />
				)}
			</ListItemButton>
			<StyledMenu
				anchorEl={menuAnchorEl}
				open={open}
				onClose={onToggle}
			>
				{children}
			</StyledMenu>
		</Box>
	);
};

const Navigation = ({ drawerOpen, onToggleDrawer, menuData, user }) => {
	const [state, setState] = useState({
		sectionMenuAnchorEl: null,
		subSectionMenuAnchorEl: null,
		openSection: false,
		openSubSectionId: null,
		openSubSection: null,
		serviceState: true
	});
	const snackbar = useSnackbar();
	useEffect(() => {
		if (!drawerOpen) {
			setState({
				sectionMenuAnchorEl: null,
				subSectionMenuAnchorEl: null,
				openSection: false,
				openSectionId: null,
				openSubSectionId: null,
				openSubSection: null
			});
		}

	}, [drawerOpen, setState]);

	const handleOnToggleNavMenuSection = useCallback(
		(id) => (e) => {
			const openSection = id === state.openSectionId ? !state.openSection : !!id;
			setState(prevState => {
				const newState = {
					...prevState,
					sectionMenuAnchorEl: openSection ? e?.target : null,
					openSectionId: id,
					openSection: openSection
				};
				return newState;
			});
		},
		[state]
	);

	const handleOnToggleNavMenuSubSection = useCallback(
		(id) => (e) => {
			setState(prevState => {
				const openSubSection = id === prevState.openSubSectionId ? !prevState.openSubSection : !!id;
				const newState = {
					...prevState,
					subSectionMenuAnchorEl: openSubSection ? e?.target : null,
					openSubSectionId: id,
					openSubSection: openSubSection
				};
				return newState;
			});
		},
		[state]
	);


	const username = user.username;

	const NavSubMenuComponent = drawerOpen ? NavMenuSection : NavMenuPopup;
	const NavLinkItem = drawerOpen ? NavMenuSectionLink : NavMenuPopupLink;

	const [navigationMenu, setMenu] = useState([]);

	function sortTree(nodes) {
		nodes.sort((a, b) => a.displayOrder - b.displayOrder);
		nodes.forEach(node => {
			if (node.children.length > 0) {
				sortTree(node.children);
			}
		});
	}

	function buildMenuTree(data) {
		// Create a map to hold references to all menu items by their IDs
		const menuMap = new Map();

		// First, transform each menu item to include desired properties
		data.forEach(item => {
			menuMap.set(item.MenuId, {
				id: item.MenuId,
				text: item.MenuName,
				url: item.Url,
				draggable: true,
				icon: item.Icon,
				displayOrder: item.DisplayOrder,
				children: []
			});
		});
		// Build the tree structure
		const menuTree = [];
		data.forEach(item => {
			const menuItem = menuMap.get(item.MenuId);

			if (item.ParentId === 0) {
				// Top-level item, add to root array
				menuTree.push(menuItem);
			} else {
				// Add item as a child of its parent
				const parentItem = menuMap.get(item.ParentId);
				if (parentItem) {
					parentItem.children.push(menuItem);
				}
			}
		});

		// Sort the menu tree
		sortTree(menuTree);

		return menuTree;
	}

	const fetchMenu = async () => {
		try {
			const result = buildMenuTree(menuData);  //fetching menu data only at user login and using the fetched data here
			setMenu(result);
		} catch (error) {
			snackbar.showError(error?.message || 'Failed to fetch menu data');
		}

	};

	useEffect(() => {
		fetchMenu();
	}, [menuData]);

	return (
		<Drawer
			variant="permanent"
			open={drawerOpen}
			className="print-hide no-print"
			sx={{
				'& .SubMenu-Indicator-Icon': {
					color: 'primary.contrastText'
				},
				'& .Nav-Menu-Link': {
					'& .Nav-Menu-Link': { pl: 4 },
					'&.Mui-selected': { backgroundColor: 'action.selected' }
				},
				'& .Nav-Menu-SubSection': {
					'& .Nav-Menu-Popup': {
						'& .Mui-selected': { backgroundColor: 'action.active' },
						'& .MuiListItemButton-root': { backgroundColor: 'action.active' },
						'& .MuiMenu-paper': {
							backgroundColor: (theme) => `${theme.palette.primary.light} !important`,
							color: 'primary.contrastText'
						}
					}
				}
			}}
		>
			<DrawerHeader>
				<Box
					sx={{
						display: 'flex',
						flexDirection: drawerOpen ? 'row-reverse' : 'column',
						width: '100%'
					}}
				>
					<IconButton
						onClick={onToggleDrawer}
						sx={{
							width: (theme) => theme.spacing(5),
							height: (theme) => theme.spacing(5),
							color: (theme) => theme.palette.background.paper
						}}
					>
						<span className={`fa fa-bars`} />
					</IconButton>
					<Box sx={{ flex: 1 }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<Box
								component="img"
								alt="image"
								className="img-circle"
								src={AvatarLogo}
								sx={{
									width: 36,
									height: 36
								}}
							// onClick={onUserclick} it will be used in future
							/>
							{drawerOpen && (
								<p
									style={{ color: '#fff', textDecoration: 'underline', marginLeft: 10 }}
									// onClick={onUserclick} it will be used in future
									title={username}
								>
									{username}
								</p>
							)}
						</div>
					</Box>
				</Box>
			</DrawerHeader>
			<Divider />
			<DrawerBody>
				<List sx={{ width: '100%', maxWidth: 360, bgcolor: 'transparent' }} component="nav">
					{navigationMenu.map(({ children, ...menu }, index) =>
						children?.length > 0 ? (
							<NavSubMenuComponent
								{...menu}
								onToggle={handleOnToggleNavMenuSection(menu.id)}
								drawerOpen={drawerOpen}
								menuAnchorEl={state.sectionMenuAnchorEl}
								className="nav-first-submenu"
								open={state.openSection && state.openSectionId === menu.id}
								key={`nav-menu-section-${index}`}
							>
								{children.map(({ children: grandChildren, ...subMenu }, cursor) =>
									grandChildren?.length > 0 ? (
										<NavSubMenuComponent
											{...subMenu}
											onToggle={handleOnToggleNavMenuSubSection(subMenu.id)}
											drawerOpen={drawerOpen}
											className="nav-second-submenu"
											menuAnchorEl={state.subSectionMenuAnchorEl}
											open={state.openSubSection && state.openSubSectionId === subMenu.id}
											key={`nav-menu-section-${index}-subsection-${cursor}`}
										>
											{grandChildren.map((grandChild) => (
												<NavLinkItem
													{...grandChild}
													drawerOpen={drawerOpen}
													key={`nav-menu-link-${grandChild.id}`}
												/>
											))}
										</NavSubMenuComponent>
									) : (
										<NavLinkItem
											{...subMenu}
											drawerOpen={drawerOpen}
											key={`nav-menu-link-${subMenu.id}`}
										/>
									)
								)}
							</NavSubMenuComponent>
						) : (
							<NavLinkItem {...menu} drawerOpen={drawerOpen} key={`nav-menu-link-${index}`} />
						)
					)}
				</List>
			</DrawerBody>
			{drawerOpen && (
				<DrawerFooter>
					<Box className="drawer-footer-logo">
						<img src={SterisSmallLogo} alt={"Steris Corporation"} />
					</Box>
					<Stack>
						<Typography component="span" variant="body2" color="primary.contrastText" paragraph>
							Scope Compatibility Matrix v1
						</Typography>

						<Typography component="span" variant="body2" color="primary.contrastText" paragraph>
							Copyright &copy; Steris Corporation {new Date().getFullYear()}
						</Typography>

					</Stack>
				</DrawerFooter>
			)}
		</Drawer>
	);
};

export default Navigation;
